import IMAGES from "@/public/assets/img";

const dealerFinancing = {
  seoData: {
    title: "Dealer & Distributor Financing for OEMs | Reduce DSO & Boost Sales",
    description:
      "Enable dealer and distributor financing to reduce DSO, boost primary billing, and eliminate credit risk. Structured channel finance solutions for OEMs.",
  },
  bannerHeading:
    '<span class="font-medium text-3xl md:text-heading sm:text-base2">Boost Primary Sales with Structured</span> <span class="font-medium text-headingbig md:text-heading2 sm:text-heading3">Channel Financing</span>',
  subheading:
    "Unlock liquidity for your distributor network get paid upfront while they pay later",
  paraLoan:
    "Credlix Channel Financing program enables OEMs and large brands to offer distributor credit at scale without increasing balance sheet risk. Zero credit risk to anchors. Fully digital onboarding. Pan-India deployment. ",
  btntext: "Talk to Our SCF Expert",
  btntext2: "Schedule a Demo",
  heroBanner: IMAGES?.dealerFinancing.dealerImage,

    benefits: [
      {
        id: 1,
        icon: IMAGES?.dealerFinancing.RBILogo,
        text: "RBI-licensed NBFC platform ",
      },
      {
        id: 2,
        icon: IMAGES?.dealerFinancing.msme,
        text: "Trusted by 2,500+ enterprises & MSMEs ",
      },
      {
        id: 3,
        icon: IMAGES?.dealerFinancing.cities,
        text: "Active across 120+ cities ",
      },
      {
        id: 4,
        icon: IMAGES?.dealerFinancing.ERP,
        text: "Integrated with ERP & dealer networks ",
      },
    ],

  primarySales: {
    sectionTitle: "The real problem OEMs face",
    mainHeading: "Primary Sales is <b>Capped by Distributor Liquidity</b>",
    highValueImage: [
      {
        id: 1,
        icon: IMAGES?.dealerFinancing.dealers,
        description: "Dealers struggle with working capital limits",
      },
      {
        id: 2,
        icon: IMAGES?.dealerFinancing.invontory,
        description: "Inventory funding is inconsistent",
      },
      {
        id: 3,
        icon: IMAGES?.dealerFinancing.document,
        description: "Sales teams push credit risk to finance",
      },
      {
        id: 4,
        icon: IMAGES?.dealerFinancing.credit,
        description: "Credit control slows down billing",
      },
      {
        id: 5,
        icon: IMAGES?.dealerFinancing.distributor,
        description: "Distributor churn due to liquidity stress",
      },
    ],
  },

  setUpProgram: {
    heading: "Are these bottlenecks holding back your growth?",
    btntext: "Set Up a Distributor Program",
    whySection: [
      {
        id: 1,
        image: IMAGES?.dealerFinancing.billing,
        text: "Lagging Sales​",
        text2:"When distributors lack credit, your primary billing suffers."
      },
      {
        id: 2,
        image: IMAGES?.dealerFinancing.seo,
        text: "Capital Inefficiency​",
        text2: "High DSO and slow collections limit your reinvestment power.",
      },
      {
        id: 3,
        image: IMAGES?.dealerFinancing.channel,
        text: "Operational Hurdles",
        text2: "Manual credit checks and collection follow-ups create friction.",
      },
    ],
  },

  HowItWorks: {
    mainHeading: "Structured Distributor Finance Program for OEMs",
    subheading:
      "Credlix enables brands to offer inventory funding to dealers without taking credit exposure on their own books",
    sectionTitle: "How it Works",
    whySection: [
      {
        id: 1,
        text: "OEM approves distributor cohort",
        color: "#5AC1A9"
      },
      {
        id: 2,
        text: "Credlix underwrites distributor credit",
        color: "#2D8AC7"
      },
      {
        id: 3,
        text: "Dealer purchases inventory",
        color: "#F5A623"
      },
      {
        id: 4,
        text: "OEM receives payment upfront",
        color: "#E96A78"
      },
      {
        id: 5,
        text: "Dealer repays Credlix as per tenure",
        color: "#4CC3C7"
      }
    ]
  },

  keyFeatures: {
    sectionTitle: "Key Features",
    cases: [
      {
        id: 1,
        text: "Distributor finance program India",
      },
      {
        id: 2,
        text: "FMCG distributor finance model",
      },
      {
        id: 3,
        text: "Inventory funding for dealers​",
      },
      {
        id: 4,
        text: "Consumer durables sales finance",
      },
      {
        id: 5,
        text: "Dealer loan / Distributor loan structuring",
      },
      {
        id: 6,
        text: "Electronics & Pharma distribution funding",
      },
    ],
  },

  benefitsOEMs: {
    sectionTitle: "Benefits for OEMs",
    subheading:
      "Credlix enables brands to offer inventory funding to dealers without taking credit exposure on their own books",
    image: IMAGES?.dealerFinancing.oems,
    industryUse: [
      {
        id: 1,
        heading: "Zero Credit Risk",
        subHeading: "Credit exposure sits with Credlix, not the Anchor.",
        color: "#F0F7FF"
      },
      {
        id: 2,
        heading: "Faster Primary Sales",
        subHeading:
          "Unlock 20–35% potential sales increase in distributor-heavy networks.",
        color: "#FFFAED"
      },
      {
        id: 3,
        heading: "Improved Dealer Stickiness",
        subHeading: "Access to structured inventory credit increases loyalty.",
        color: "#FEF4EF"
      },
      {
        id: 4,
        heading: "Better Sales Channel Optimization",
        subHeading: "Align procurement, treasury, and sales KPIs.",
        color: "#F0FFF0"
      },
    ]
  },
  industryUseCases: {
    sectionTitle: "Industry Use Cases",
    industryUse: [
      {
        id: 1,
        image: IMAGES?.dealerFinancing.fmcg,
        heading: "FMCG & Consumer Goods",
        subHeading: "HUL / P&G / Nestle-type distribution models",
      },
      {
        id: 2,
        image: IMAGES?.dealerFinancing.durables,
        heading: "Auto & Consumer Durables",
        subHeading: "Dealer inventory financing for Tier 1 & Tier 2 cities​",
      },
      {
        id: 3,
        image: IMAGES?.dealerFinancing.pcb,
        heading: "Electronics & PCB Manufacturers",
        subHeading:
          "Component inventory & finished goods financing",
      },
      {
        id: 4,
        image: IMAGES?.dealerFinancing.pharma,
        heading: "Pharma & Packaging",
        subHeading:
          "Stockist & distributor credit for pharma networks",
      },
    ],
  },

  capitalEfficency: {
    sectionTitle: "Designed to Multiply Participation and Capital Efficiency",
    capitalParticipation: [
      {
        id: 1,
        image: IMAGES?.dealerFinancing.improvement,
        heading: "2–5x improvement",
        subHeading: "in vendor participation",
      },
      {
        id: 2,
        image: IMAGES?.dealerFinancing.Offbalance,
        heading: "Instant Liquidity",
        subHeading: "accelerated cash cycles",
      },
      {
        id: 3,
        image: IMAGES.dealerFinancing.ERPintegrated,
        heading: "ERP-integrated",
        subHeading: "touchless disbursement",
      },
      {
        id: 4,
        image: IMAGES?.dealerFinancing.algorithm,
        heading: "Algorithm-based",
        subHeading: "cohort underwriting",
      },
    ],
  },

  FaqHead: "Frequently Asked Questions",
  Faq: [
    {
      id: 0,
      question: "What is channel financing and how does it optimize the Indian supply chain?",
      answers:
        "Channel financing, often referred to as distributor or dealer financing, is a structured credit program where Credlix -an RBI-licensed NBFC provides upfront payment to an OEM (Anchor) while extending flexible credit terms to its distributors to purchase inventory. This model optimizes the supply chain by reducing the Anchor’s Days Sales Outstanding (DSO) and ensuring that distributors maintain optimal stock levels without straining their own working capital. Unlike traditional trade credit, this facility is tightly linked to actual trade transactions, providing a more predictable flow of liquidity across the network.",
    },
    {
      id: 1,
      question: "How does Credlix distributor financing differ from traditional bank-led dealer loans?",
      answers: "Traditional dealer loans typically rely on individual creditworthiness and require significant collateral, leading to slow onboarding cycles of 30 to 60 days. In contrast, Credlix utilizes an anchor-approved cohort underwriting model, which assesses the risk of the entire distribution network rather than individual entities in isolation. This algorithm-based approach allows for fully digital onboarding across 120+ cities and a go-live timeline of just 7 to 14 days. Furthermore, Credlix integrates directly with the Anchor’s ERP system to enable touchless disbursements within 24 to 48 hours of invoice acceptance. ",
    },
    {
      id: 2,
      question: "Does the OEM or Anchor carry any credit risk in a Credlix channel finance program?",
      answers:
        "No. A defining characteristic of the Credlix program is that it is structured as non-recourse financing for Anchor, meaning the entire credit exposure sits with Dealer/Distributor rather than the Anchor. The OEM only approves the distributor cohort and validates the transaction, receiving up to 100% payment upon dispatch. This is a critical advantage for CFOs, as it allows for an off-balance sheet structure that does not increase the brand’s contingent liabilities or balance sheet risk.",
    },
    {
      id: 3,
      question: "Which industry sectors benefit most from Credlix’s structured channel financing?",
      answers: "Credlix’s solutions are optimized for high-volume distribution networks in sectors such as FMCG, Pharmaceuticals, Consumer Durables, and Electronics. In these industries, the ability to offer inventory credit at scale is a primary driver of dealer stickiness and loyalty. Our clients have historically observed a 20% to 35% uplift in primary billing and a 2x to 5x improvement in vendor participation by removing liquidity stress from the channel.",
    },
    {
      id: 4,
      question: "Is Credlix channel financing an off-balance sheet solution for large brands?",
      answers: "Because the program involves the purchase of receivables without recourse to the Anchor, it is classified as a structured lending product rather than a guarantee. This allows CFOs to enhance liquidity and improve cash conversion cycles without negatively impacting the company’s leverage ratios or debt-to-equity metrics. ",
    },
    {
      id: 5,
      question: "How can an OEM initiate a pilot program with Credlix?",
      answers: "The process begins with a consultation with our Supply Chain Finance structuring team to map the current distribution channel and identify high-potential cohorts. Credlix provides a customized pilot proposal within 48 hours, detailing the interest rates, credit limits, and integration roadmap.",
    },
  ],
};
export default dealerFinancing;
